import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import BrandMark from '../../BrandMark/BrandMark';
import Icon from '../../ui/Icon/Icon';
import LanguageSelect from '../LanguageSelect/LanguageSelect';
import europeMap from '../../../assets/img/europe-germany.svg?url';
import { CONTACT_EMAIL, SOCIAL_LINKS, legalNavigation, studioNavigation } from '../../../data/navigation';
import { plainProjectName, projects } from '../../../data/projects';
import { useConsent } from '../../../consent/useConsent';
import { useLanguage } from '../../../i18n/useLanguage';
import styles from './SiteFooter.module.css';

function MadeInGermany() {
    const { t } = useTranslation();

    return (
        <figure className={styles.made}>
            <div className={styles.map}>
                <img src={europeMap} alt={t('footer.mapAlt')} width={445} height={445} loading="lazy" decoding="async" />
            </div>
            <figcaption className={styles.madeCaption}>
                <span className={styles.madeIn}>Made in Germany</span>
            </figcaption>
        </figure>
    );
}

export default function SiteFooter() {
    const { t } = useTranslation();
    const { localizedPath } = useLanguage();
    const { openSettings } = useConsent();
    const year = new Date().getFullYear();

    return (
        <footer className={styles.footer} data-theme="dark">
            <div className={`page-inner ${styles.top}`}>
                <div className={styles.brand}>
                    <BrandMark className={styles.logo} />
                    <p className={styles.tagline}>{t('footer.tagline')}</p>
                    <a className={styles.email} href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a>
                    <ul className={styles.socials}>
                        {SOCIAL_LINKS.map((social) => (
                            <li key={social.href}>
                                <a className={styles.social} href={social.href} target="_blank" rel="noopener noreferrer" aria-label={social.label}>
                                    <Icon name={social.icon} className={styles.socialIcon} />
                                </a>
                            </li>
                        ))}
                    </ul>
                </div>

                <nav className={styles.columns} aria-label={t('a11y.footerNav')}>
                    <div className={styles.projectsColumn}>
                        <h2 className={styles.heading}>{t('footer.projectsTitle')}</h2>
                        <ul className={`${styles.list} ${styles.projectList}`}>
                            {projects.map((project) => (
                                <li key={project.slug}>
                                    <Link to={localizedPath(`/work/${project.slug}`)}>{plainProjectName(project)}</Link>
                                </li>
                            ))}
                        </ul>
                    </div>
                    <div>
                        <h2 className={styles.heading}>{t('footer.studioTitle')}</h2>
                        <ul className={styles.list}>
                            {studioNavigation.map((item) => (
                                <li key={item.path}><Link to={localizedPath(item.path)}>{t(item.labelKey)}</Link></li>
                            ))}
                        </ul>
                    </div>
                    <div>
                        <h2 className={styles.heading}>{t('footer.legalTitle')}</h2>
                        <ul className={styles.list}>
                            {legalNavigation.map((item) => (
                                <li key={item.path}><Link to={localizedPath(item.path)}>{t(item.labelKey)}</Link></li>
                            ))}
                            <li><button type="button" className={styles.linkButton} onClick={openSettings}>{t('footer.cookieSettings')}</button></li>
                        </ul>
                    </div>
                </nav>

                <MadeInGermany />
            </div>

            <div className={`page-inner ${styles.bar}`}>
                <div className={styles.barText}>
                    <p>{t('footer.copyright', { year })}</p>
                    <p><Link to={`${localizedPath('/work')}#cms`}>{t('footer.cms')}</Link></p>
                </div>
                <LanguageSelect placement="above" />
            </div>

            <div className={styles.giant} aria-hidden="true">
                <BrandMark variant="wordmark" className={styles.giantMark} />
            </div>
        </footer>
    );
}
